import React from 'react';
//import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles';

import Avatar from '@material-ui/core/Avatar';
import Skeleton from '@material-ui/lab/esm/Skeleton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
//import EmailIcon from '@material-ui/icons/Email';
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import { TextField, Divider, Typography } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import PropTypes from 'prop-types';
import UserInfoLoader from './UserInfoLoader';
// import Title from './../Complements/Title';
import { useSelector } from 'react-redux';
const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  root2: {
    backgroundColor: theme.palette.background.paper,
    width: 500,
    position: 'relative',
    minHeight: 300,
  },
  paper: {
    height: 500,
    width: 400,
  },
  control: {
    padding: theme.spacing(2),
  },
  card: {
    height: 500,
    width: 400,
    maxWidth: 345,
    backgroundColor: "#EEEFF2"
  },
  card2: {
    height: 100,
    width: 100,
    maxWidth: 345,
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  avatar: {
    backgroundColor: '#b98919',
    color:"#fff"
  },
  fab: {
    position: 'absolute',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
  rowIcon: {
    top: '40%'
  },
  titleDark: {
    // color: '#000000',
    fontSize: '0.875rem',
    //fontFamily: 'MyriadPro-Bold'
  },
  titleLight: {
    // color: '#000000',
    fontSize: '0.875rem',
    //fontFamily: 'MyriadPro-SemiBold',
  },
  titleGreenBlackPrimary: {
    color: '#b98919',
    fontSize: '1.05rem',
    //fontFamily: 'MyriadPro-Bold'
  },
  titleGreenBlackSecondary: {
    // color: '#000000',
    fontSize: '1rem',
    //fontFamily: 'MyriadPro-SemiBold'
  },
  divStandard: {
    padding: "20px",
    // border: '2px solid #BEBCC0',
    backgroundColor: theme.palette.type === 'dark' ? '#4a4a4a' : '#fafafa',

    borderRadius: "16px",
    // boxShadow: '4px 4px 4px 0px rgba(46,46,46,0.75)'
  }
}));
const UserPanelInfo = props => {
  const classes = useStyles();
  const { user, balances, accountSelected, changeAccount, tittle } = props
  const permissions = useSelector(state => state.permissions)
  //console.log('balances: ', balances)
  // const { owner, name, number, accname } = userSelected

  const handleMaskNumberAccount = (numberBeneficiary) => {

    if (numberBeneficiary.length > 7) {

      let resultConvert = ""

      const [a, b, c, d, ...dataConvert] = numberBeneficiary

      const inicioFin = dataConvert.length - 3

      const ultimos = dataConvert.join('').slice(inicioFin, dataConvert.length)

      for (let y = 0; y < inicioFin; y++) {
        resultConvert = resultConvert.concat("X")
      }

      resultConvert = a + b + c + d + resultConvert + ultimos

      return resultConvert

    } else {

      return numberBeneficiary

    }
  }

  return (
    user ?
      <div className={classes.divStandard}>
        <Typography>{tittle}</Typography>
        <List className={classes.root}>
          <ListItem alignItems="flex-start">
            <ListItemAvatar>
              <Avatar aria-label="recipe" className={classes.avatar}>
                {user ? (user.ClientType === 2) ? user.Name.charAt(0) : user.FirstName.charAt(0) : <Skeleton variant="circle" width={40} height={40} />}
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary={<span className={classes.titleDark}>
                {
                  user ?
                    user.Name :
                    <Skeleton height={10} width="80%" style={{ marginBottom: 6 }} />
                }
              </span>}
              secondary={
                <>
                  <span className={classes.titleLight}>
                    {
                      balances ? `${accountSelected.PRODUCTALIAS}` : <Skeleton height={10} width="40%" />
                    }
                  </span>
                  <br></br>
                  <span className={classes.titleLight}>
                    {
                      balances ? `${handleMaskNumberAccount(accountSelected.PRODUCTBANKID)}` : <Skeleton height={10} width="40%" />
                    }
                  </span>
                </>
              }
            />
          </ListItem>
        </List>
        <Divider></Divider>
        <br></br>

        <Autocomplete
          id="combo-box-demo"
          className={classes.titleLight}
          value={accountSelected}
          options={balances}
          onChange={(e, nv) => {
            changeAccount(nv)
          }}
          disableClearable
          getOptionLabel={(option) => `${handleMaskNumberAccount(option.PRODUCTBANKID)} - ${option.PRODUCTALIAS}`}
          renderOption={(option) => (
            <React.Fragment>
              {`${handleMaskNumberAccount(option.PRODUCTBANKID)} - ${option.PRODUCTALIAS}`}
            </React.Fragment>
          )}
          renderInput={(params) => <TextField {...params} label="Seleccione una cuenta" variant="outlined" fullWidth />}
        />
        <br></br>
        <Divider></Divider>

        <List className={classes.root}>
          <ListItem >
            <ListItemAvatar>
              <Avatar style={{ color: '#2E2757', backgroundColor: '#EEEFF2' }}>
                <LocalAtmIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary={
                <span className={classes.titleGreenBlackSecondary}>
                  Saldo Disponible
                </span>
              }
              secondary={
                <span className={classes.titleGreenBlackPrimary}>
                  {(permissions.includes(11) ?  `$ ${accountSelected.SALDO}` : '****.**')}
                </span>
              } />
          </ListItem>
          <ListItem >
            <ListItemAvatar>
              <Avatar style={{ color: '#2E2757', backgroundColor: '#EEEFF2' }}>
                <MailOutlineIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary={<span className={classes.titleGreenBlackSecondary}>
                Correo Electrónico
              </span>}
              secondary={<span className={classes.titleGreenBlackSecondary}>
                {(user.Mail === null) ? "" : user.Mail}
              </span>}
            />
          </ListItem>
        </List>
      </div> :
      <UserInfoLoader classes={classes} />
  );
};

UserPanelInfo.propTypes = {
  user: PropTypes.object.isRequired,
  balances: PropTypes.array.isRequired,
  accountSelected: PropTypes.object.isRequired,
  changeAccount: PropTypes.func.isRequired,
};

export default UserPanelInfo;
